import { render } from "./ManagerHomePageView.vue?vue&type=template&id=07cb5e3a"
import script from "./ManagerHomePageView.vue?vue&type=script&lang=js"
export * from "./ManagerHomePageView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__